module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter-stats"
  }, [_c('div', {
    staticClass: "chapter-square-main shrink-on-active",
    class: {
      chaptersquareactive: _vm.page == 'savedwords'
    },
    on: {
      "click": function($event) {
        return _vm.changePage('savedwords')
      }
    }
  }, [_c('p', {
    staticClass: "statNum",
    class: {
      notSelected: _vm.page !== 'savedwords'
    }
  }, [_vm._v("\n      " + _vm._s(_vm.words) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "statText"
  }, [_vm._v("\n      " + _vm._s(_vm.$t("chapter.chapter-stats.words")) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "chapter-square-main shrink-on-active",
    class: {
      chaptersquareactive: _vm.page == 'grammar'
    },
    on: {
      "click": function($event) {
        return _vm.changePage('grammar')
      }
    }
  }, [_c('p', {
    staticClass: "statNum",
    class: {
      notSelected: _vm.page !== 'grammar'
    }
  }, [_vm._v("\n      " + _vm._s(_vm.grammer) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "statText"
  }, [_vm._v("\n      " + _vm._s(_vm.$t("chapter.chapter-stats.grammar")) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "chapter-square-main shrink-on-active",
    class: {
      chaptersquareactive: _vm.page == 'sentence'
    },
    on: {
      "click": function($event) {
        return _vm.changePage('sentence')
      }
    }
  }, [_c('p', {
    staticClass: "statNum",
    class: {
      notSelected: _vm.page !== 'sentence'
    }
  }, [_vm._v("\n      " + _vm._s(_vm.sentance) + "\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "statText"
  }, [_vm._v("\n      " + _vm._s(_vm.$t("chapter.chapter-stats.sentences")) + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3120e01e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter/chapter-stats.vue
// module id = 518
// module chunks = 0